import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Button } from '@cellula/react';
import { useResolve } from '@visiba/instantiation';
import { ConsentDialog } from './consent_dialog.component';

interface Props {}

export function ConsentTrigger(_: Props) {
	const universalConfig = useResolve(UniversalConfig);

	if (universalConfig.disableTrackingCookies) {
		return null;
	}

	return (
		<ConsentDialog
			trigger={
				<Button size='xSmall' variant='secondary'>
					{withTranslation('Component.Consent.Trigger.Button')}
				</Button>
			}
		/>
	);
}
